module.exports = __webpack_public_path__ + "img/mp4.9ea014dd.svg";